(function(){
    'use strict'

    angular
    .module('app.contratos')
    .controller('contratos.Edit', Edit);

    Edit.$inject = ['$q', '$scope', '$animationsSrv', '$routeParams','ApiBaseService', 'logger', '$location', 'UserInfoService', 'moment'];

    function Edit($q, $scope, $animationsSrv, $routeParams, ApiBaseService, logger, $location, UserInfoService, moment) {
    
        $animationsSrv.scrollToTop();
        const apiContratos = 'api/Contratos'
        const companiaId = UserInfoService.getCompaniaId();

        let vm = this;

        vm.data = {
            clienteId: 0,
            proyectoId: 0,
            moneda:"0"
        };

        vm.title = 'Contratos';
        vm.id = $routeParams.id ? $routeParams.id : 0;

        vm.openFechaInicio = function(){
            vm.fechaInicioOpened = !vm.fechaInicioOpened;
        };

        vm.openFechaFinal = function(){
            vm.fechaFinalOpened = !vm.fechaFinalOpened;
        };

        vm.clientes = [];
        vm.proyectos = [];

        const promiseClientes = getComboData(vm.clientes, 'api/Clientes', [companiaId], 'Error al obtener los clientes.');

        get();

        function getComboData(array, apiUrl, params, errorMessage){
            ApiBaseService.remoteController = apiUrl;
            var promise = ApiBaseService.getAll(params)
            .then(function(data){
                array.splice(0);
                array.push(...data);
            })
            .catch(function(error){
                $logger.error(errorMessage);
            }); 
            
            return promise;
        };

        function get(){

            $q.all([promiseClientes])
            .then(function(){
                if(vm.id != 0){
                    ApiBaseService.remoteController = apiContratos;
                    var promise = ApiBaseService.getAll([companiaId, vm.id]);

                    promise
                    .then(function(data){
                        data.fechaInicio = moment(data.fechaInicio).toDate();
                        data.fechaFinal = moment(data.fechaFinal).toDate();
                        vm.data = Object.assign(vm.data, data);

                        vm.data.proyectoId = 0;

                        const promiseProyectos = getComboData(vm.proyectos, 'api/Proyectos/Cliente', [companiaId, vm.data.clienteId], 'Error al obtener los proyectos.');

                        promiseProyectos.then(function(){
                            vm.data.proyectoId = data.proyectoId;
                        });
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 401:
                                logger.error('La sesión ha expirado');
                                break;
                        
                            default:
                                logger.error('Hubo un error al obtener el registro: ' + error.data.Message);
                                break;
                        }
                    });               
                }               
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al obtener los datos: ' + error.data.Message);
                        break;
                }
            }); 

        };

        function doFormValidations()
        {
            validateSelectProperty('moneda');
            validateSelectProperty('clienteId');
            if(!vm.data.todosLosProyectos)
            {
                validateSelectProperty('proyectoId');               
            }

            validateDates();
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormValidations();

            if($scope.dataForm.$valid){
                if(!vm.data.id){
                    create();
                }
                else if($scope.dataForm.$dirty){
                    update();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function create() {
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiContratos;
            var promise = ApiBaseService.save(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro creado con éxito.');
                clearData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function update(){
            vm.data.cia_codigo = companiaId;
            ApiBaseService.remoteController = apiContratos;
            var promise = ApiBaseService.update(vm.data);
            
            promise
            .then(function(response){
                logger.success('Registro modificado con éxito.');
                $location.path('/contratos');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el registro: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.data = {
                clienteId: 0,
                proyectoId: 0,
                moneda:"0"
            };
            // Set back to pristine.
            $scope.dataForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.dataForm.$setUntouched();
        };

        function validateSelectProperty(property){
            if(vm.data[property] == 0){
                $scope.dataForm[property].$setValidity("different", false);
            }
            else{
                $scope.dataForm[property].$setValidity("different", true);
            }
        };

        function validateDates()
        {
            if(vm.data.fechaInicio > vm.data.fechaFinal){
                $scope.dataForm.fechaInicio.$setValidity("rangeDates", false);
            }
            else{
                $scope.dataForm.fechaInicio.$setValidity("rangeDates", true);
            }
        };

        vm.onCheckBoxChanged = function(){
            if(vm.data.todosLosProyectos)
            {
                $scope.dataForm['proyectoId'].$setValidity("different", true);
            }
            else{
                validateSelectProperty('proyectoId');
            }
        };

        vm.onSelectChanged = function(property){

            if(property == 'proyectoId')
            {
                if(!vm.data.todosLosProyectos)
                {
                    validateSelectProperty(property);
                }
                else
                {
                    $scope.dataForm[property].$setValidity("different", true);
                }
            }
            else 
            {
                validateSelectProperty(property);            
            }

            if(property == 'clienteId')
            {
                filtrarProyectos();
            }
            
        };

        function filtrarProyectos()
        {
            if(vm.data.clienteId != 0)
            {
                const promiseProyectos = getComboData(vm.proyectos, 'api/Proyectos/Cliente', [companiaId, vm.data.clienteId], 'Error al obtener los proyectos.');

                promiseProyectos.then(function(){
                    vm.data.proyectoId = 0;
                });
            }
        };

    }
})();